module.exports = __webpack_public_path__ + "img/head-but-1.a806ea1.webp";